declare global {
  interface Window {
    CTN_CONFIG?: {
      readonly wsUrl?: string;
    };
  }
}

export function resolveWebSocketUrl():
string {
  const override =
    new URLSearchParams(
      window.location.search,
    ).get("ws");

  const configured =
    override ??
    window.CTN_CONFIG?.wsUrl;

  if (configured) {
    const parsed =
      new URL(configured);

    if (
      parsed.protocol !== "ws:" &&
      parsed.protocol !== "wss:"
    ) {
      throw new Error(
        "WebSocket URL must use ws:// or wss://.",
      );
    }

    return parsed.toString();
  }

  const protocol =
    window.location.protocol ===
    "https:"
      ? "wss:"
      : "ws:";

  return `${protocol}//${window.location.host}/ws`;
}
